const openLinkInNewTab = (link) => {
  window.open(link, '_blank');
};

export default openLinkInNewTab;
